module.exports = __webpack_public_path__ + "static/media/canada.7d9b52b1.webp";